import { z } from 'zod/v3';

// Flow DTOs
export const FlowDTOSchema = z.object({
  id: z.string(),
  startTime: z.date(),
  endTime: z.date().nullable(),
  workspaceId: z.string(),
  topicId: z.string().nullable(),
  sectionId: z.string().nullable(),
  guidedTemplateId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  // Relations as IDs
  flowProcessingJob: z.object({
    id: z.string(),
  }).optional(),
  steps: z.array(z.string()).optional(),
  htmlSnapshots: z.array(z.string()).optional(),
  domDiffs: z.array(z.string()).optional(),
  screenshots: z.array(z.string()).optional(),
  sources: z.array(z.string()).optional(),
  videos: z.array(z.string()).optional(),
  productVersions: z.array(z.string()).optional(),
}).strict();

export const FlowListDTOSchema = z.object({
  id: z.string(),
  title: z.string(),
  startTime: z.date(),
  endTime: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
}).strict();

export const CreateFlowDTOSchema = z.object({
  startTime: z.date().optional(),
  topicId: z.string().optional(),
  sectionId: z.string().optional(),
  guidedTemplateId: z.string().optional(),
  workspaceId: z.string()
}).strict();

export const UpdateFlowDTOSchema = z.object({
  id: z.string(),
  endTime: z.date().optional(),
}).strict();

export const EndFlowDTOSchema = z.object({
  id: z.string(),
  endTime: z.date(),
}).strict();

export const DeleteFlowDTOSchema = z.object({
  id: z.string(),
}).strict();

export const GetFlowsQueryDTOSchema = z.object({
  topicId: z.string().optional(),
  workspaceId: z.string().optional(),
  limit: z.number().min(1).max(100).default(50),
  cursor: z.string().optional(),
}).strict();

// Export types
export type FlowDTO = z.infer<typeof FlowDTOSchema>;
export type FlowListDTO = z.infer<typeof FlowListDTOSchema>;
export type CreateFlowDTO = z.infer<typeof CreateFlowDTOSchema>;
export type UpdateFlowDTO = z.infer<typeof UpdateFlowDTOSchema>;
export type EndFlowDTO = z.infer<typeof EndFlowDTOSchema>;
export type DeleteFlowDTO = z.infer<typeof DeleteFlowDTOSchema>;
export type GetFlowsQueryDTO = z.infer<typeof GetFlowsQueryDTOSchema>;
